var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmarkWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_849_246",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_849_246)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60001 6.4C5.60001 5.76348 5.85286 5.15303 6.30295 4.70294C6.75304 4.25286 7.36349 4 8.00001 4H16C16.6365 4 17.247 4.25286 17.6971 4.70294C18.1472 5.15303 18.4 5.76348 18.4 6.4V19.2224C18.4 20.1984 17.296 20.7664 16.5024 20.1992L12 16.9832L7.49761 20.1992C6.70321 20.7672 5.60001 20.1992 5.60001 19.2232V6.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60001 6.4C5.60001 5.76348 5.85286 5.15303 6.30295 4.70294C6.75304 4.25286 7.36349 4 8.00001 4H16C16.6365 4 17.247 4.25286 17.6971 4.70294C18.1472 5.15303 18.4 5.76348 18.4 6.4V19.2224C18.4 20.1984 17.296 20.7664 16.5024 20.1992L12 16.9832L7.49761 20.1992C6.70321 20.7672 5.60001 20.1992 5.60001 19.2232V6.4ZM8.00001 5.6C7.78783 5.6 7.58435 5.68429 7.43432 5.83431C7.28429 5.98434 7.20001 6.18783 7.20001 6.4V18.4456L11.3024 15.5152C11.5059 15.3698 11.7499 15.2916 12 15.2916C12.2502 15.2916 12.4941 15.3698 12.6976 15.5152L16.8 18.4456V6.4C16.8 6.18783 16.7157 5.98434 16.5657 5.83431C16.4157 5.68429 16.2122 5.6 16 5.6H8.00001Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkWhite);
export default __webpack_public_path__ + "static/media/bookmark_white.df17b8b7cda29fc95bec79c96993063c.svg";
export { ForwardRef as ReactComponent };